import React from "react";
import { TouchableOpacity, TouchableOpacityProps, View } from "react-native";
import { Check } from "lucide-react-native";
import StyledText from "./styled-text";

interface CheckboxProps extends Omit<TouchableOpacityProps, "onPress"> {
  checked: boolean;
  onToggle: (checked: boolean) => void;
  disabled?: boolean;
  size?: number;
  className?: string;
  label?: string;
  labelClassName?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onToggle,
  disabled = false,
  size = 20,
  className = "",
  style,
  label,
  labelClassName = "",
  ...props
}) => {
  const handlePress = () => {
    if (!disabled) {
      onToggle(!checked);
    }
  };

  const checkboxElement = (
    <TouchableOpacity
      onPress={handlePress}
      className={`rounded items-center justify-center border ${
        disabled ? "" : ""
      } ${className}`}
      style={[
        {
          width: size,
          height: size,
          backgroundColor: disabled ? "#f8f9fa" : checked ? "#3B82F6" : "white",
          borderWidth: 1.5,
          borderColor: disabled ? "#d1d5db" : checked ? "#3B82F6" : "#d1d5db",
        },
        style,
      ]}
      disabled={disabled}
      {...props}
    >
      {checked && (
        <Check size={size * 0.7} color={disabled ? "#9ca3af" : "white"} />
      )}
    </TouchableOpacity>
  );

  if (!label) {
    return checkboxElement;
  }

  return (
    <View className="flex-row items-center space-x-3">
      {checkboxElement}
      <TouchableOpacity
        onPress={handlePress}
        disabled={disabled}
        className="flex-1"
      >
        <StyledText
          className={`text-sm ${
            disabled ? "text-gray-400 cursor-not-allowed" : "text-gray-700"
          } ${labelClassName}`}
        >
          {label}
        </StyledText>
      </TouchableOpacity>
    </View>
  );
};

export default Checkbox;
